import React, { useState } from "react";
import { useForm } from "react-hook-form";
import authHeader from "services/auth-header";
import API from "services/axios";
import { serverMessage, trackingUrlError } from "./courierFields";
import TrackingApiFields from "./TrackingApiFields";

function CouriersAdd({ showAddPage, refreshFunc, lastSortId }) {
  /*   All States Below
   ********************************************* */
  const { register, handleSubmit, watch } = useForm();
  const [formError, setFormError] = useState({});
  // redux

  /*   All Functions Below
   ********************************************* */
  const addCouriersData = async (formData, e) => {
    setFormError({});
    e.preventDefault();
    if (formData.name === "") {
      setFormError({
        name: {
          type: "name",
          message: "name is required",
        },
      });
      return;
    }
    const urlError = trackingUrlError(formData.trackingUrl);
    if (urlError) {
      setFormError({ trackingUrl: { type: "trackingUrl", message: urlError } });
      return;
    }

    try {
      const { data } = await API.post(
        "/courier-service",
        { data: { ...formData } },
        { headers: authHeader() }
      );
      if (data.message.type === "success") {
        await refreshFunc();
        showAddPage(false);
        return;
      }
    } catch (err) {
      alert(serverMessage(err));
    }
  };

  return (
    <div className="row">
      <div className="col-12">
        {/*    ADD FORM START
         ********************************************* */}
        <div className="mb-13 ms-3">
          <h3>Add Courier Service</h3>
        </div>
        <form className="ps-3 pe-3" onSubmit={handleSubmit(addCouriersData)}>
          {/* ----------  Fields  ----------- */}
          <div className="mt-3 mb-3">
            <label htmlFor="name" className="form-label">
              Service Name
            </label>
            <input
              className="form-control"
              type="text"
              id="name"
              placeholder="Enter Name"
              {...register("name")}
            />
            {formError && formError.name && (
              <p className="text-danger">{formError.name.message}</p>
            )}
          </div>

          <div className="mb-3">
            <label htmlFor="trackingUrl" className="form-label">
              Tracking URL
            </label>
            <input
              className="form-control"
              type="text"
              id="trackingUrl"
              placeholder="https://www.ups.com/track?tracknum="
              {...register("trackingUrl")}
            />
            <small className="text-muted">
              The tracking number is added to the end of this to open the
              courier's tracking page.
            </small>
            {formError && formError.trackingUrl && (
              <p className="text-danger">{formError.trackingUrl.message}</p>
            )}
          </div>

          <TrackingApiFields register={register} watch={watch} />

          {/* A logo is attached to a saved courier, so it is added from Edit. */}
          <p className="small text-muted mb-0">
            Save the courier first, then add its logo from Edit.
          </p>

          <div className={`mt-4 mb-2 d-flex justify-content-end`}>
            <div>
              <button
                className="btn px-1 btn-secondary"
                type="button"
                onClick={() => {
                  showAddPage(false);
                }}
              >
                Cancel
              </button>
              <button className="btn btn-primary ms-1" type="submit">
                Add
              </button>
            </div>
          </div>
        </form>

        {/*    ADD FORM END
         ********************************************* */}
      </div>
    </div>
  );
}

export default CouriersAdd;
